<template>
    <nuxt-layout>
        <nuxt-page class="mx-auto w-full max-w-160" />
    </nuxt-layout>
</template>
